<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="产品装配工艺"
      :page="page"
      :show-checkbox="multiple"
      :show-query="true"
       :query-params="params"
      :get-data-func="api.list"
       @check-change="checkChange"
      :reset-data-func="resetData"
      v-if="trendShow"
      urlHash="production/craftsmanship/solutions/assembly"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template> 
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/production/teProgramme').default,
      trendShow: true,
      params: {
        ProductNo: "",
        ProgrammeName: "",
      },
      tempParams: {
        ProgrammeType: 2
      },
      ids: [],
    };
  },
  methods: {
    checkChange(ids) {
      this.ids = ids.map(v => {
        return v.ProgrammeId
      });
      
    },
    _del() {
      if(this.ids.length === 0){
        this.$message({type: 'warning', message: '请选择删除的数据'});
        return;
      }
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
     
        this.api.delete({ Ids: this.ids }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.reload();
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    resetData(data){
      
      data.forEach(item => {
        let str = '';
        let length = item.Products.length
        item.Products.forEach((v, i) => {
          if(i === length - 1){
            str += v.ProductName
          }else{
            str += v.ProductName + ','
          }
        })
        item.ProductName = str;
      })
      return data
    },
  }
};
</script>
